// extracted by mini-css-extract-plugin
export default {"page":"Login_page__M50J9","form":"Login_form__bLN41"};